<template>
    <div v-if="gallery !== undefined">
        <div class="gallery" v-if="isVisible">
            <div class="container">
                <div class="header">
                    <h1>{{ gallery.title }}</h1>
                    <p class="d-none">{{ gallery.lead }}</p>
                    <p class="d-none event-date">{{ gallery.event_date }}</p>
                </div>
            </div>
            <div class="container">
                <div
                    class="row masonry-grid"
                    data-masonry='{"percentPosition": true }'
                >
                    <div
                        v-for="(file, index) in gallery.images"
                        :key="index"
                        class="mb-4 col-md-4 col-xl-3 col-sm-6 col-xs-12"
                        @click="setCurrentImage(index)"
                    >
                        <div class="image">
                            <img
                                v-img="{
                                group: 'gallery-main',
                                opened: showToolbar,
                                closed: hideToolbar,
                                changed: setCurrentImage,
                            }"
                                :src="file.thumbnail"
                                alt="image"
                                @load="imgLoaded()"
                            />
                            <div class="title">
                                {{ file.original_filename.split('.')[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="toolbar" v-if="toolbarVisible">
                <button type="button" class="brn btn-primary buy" @click="addToCart()" v-if="!inCart">
                    Adicionar ao carrinho <i class="fa fa-shopping-basket"></i>
                </button>
                <span class="in-cart" v-if="inCart">
                    Fantástico! Esta foto já está no carrinho! 💪
                </span>
            </div>
            <Transition>
                <div class="infobox" v-if="addedSuccess">
                    <i class="fa fa-check"></i> Fotografia adicionada ao carrinho <br>
                </div>
            </Transition>
        </div>
    </div>
</template>
<script>
import Masonry from "masonry-layout";
import {mapGetters} from "vuex";
import ImageSizeAPI from "../api/ImageSizeAPI";

const imageSizeAPI = new ImageSizeAPI();

export default {
    async mounted() {
        // await this.getGallery();
        this.getImageSizes();
        this.$store.dispatch('clearAddedToCart');
    },
    props: {
        gallery: {
            type: Object,
        }
    },
    name: "gallery",
    data() {
        return {
            // gallery: {},
            totalLoaded: 0,
            msry: {},
            currentIndex: 0,
            toolbarVisible: false,
            currentImage: null,
            imageSizes: [],
            file: null,
        };
    },
    updated() {
        this.totalLoaded = 0;
    },
    methods: {
        imgLoaded() {
            this.totalLoaded++;
            if (this.totalLoaded === this.gallery.images.length) {
                var grid = document.querySelector(".masonry-grid");
                this.msry = new Masonry(grid);
            }
        },

        addToCart() {
            const selectedImg = this.gallery.images[this.currentIndex];
            debugger;
            this.$store.dispatch("addToCart", {
                image: selectedImg,
                gallery: this.gallery,
            });
        },

        setCurrentImage(index) {
            this.currentIndex = index;
        },
        showToolbar() {
            this.toolbarVisible = true;
        },
        hideToolbar() {
            this.toolbarVisible = false;
        },
        getImageSizes() {
            let self = this;
            imageSizeAPI.all()
                .then(res => {
                    this.$store.dispatch('setImageSizes', res.data.data)
                    self.imageSizes = res.data.data;
                    if (self.imageSizes.length == 0) {
                        console.log('Erro: Não existem tamanhos definidos');
                    }
                }).catch(err => {
                console.log(err);
            });
        },

    },
    computed: {
        inCart() {
            const selectedImg = this.gallery.images[this.currentIndex];
            const idx = this.cart.findIndex(elem => elem.image.id === selectedImg.id);
            if (idx !== undefined && idx !== -1) {
                return true;
            }
            return false;
        },
        ...mapGetters({
            isVisible: "getGalleryVisible",
            addedSuccess: "imageAddedToCart",
            cart: "getCart"
        }),
    },
};
</script>
